/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
import{setId as e}from"../kernel.js";import{IdentityManagerBase as t}from"./IdentityManagerBase.js";class r extends t{}r.prototype.declaredClass="esri.identity.IdentityManager";const s=new r;e(s);export{s as default};
